/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environment/environment';
import { merge } from 'lodash-es';
import { AppComponent } from './app/app.component';

fetch('/config.json')
		.then(res => {
			if (res.ok) {
				return res.json();
			} else {
				return {};
			}
		})
		.then(config => {
			merge(environment, config);
			import('./app/app.config').then(config =>
					bootstrapApplication(AppComponent, config.appConfig)
							.catch(err => console.error(err)),
			);
		});
